module.exports = __webpack_public_path__ + "static/20260505_Announce_CashSweep_Q1_2026_final-59921abbf522c45060abc0e227b84a82.pdf";